export default {
  autoComplete: '/admin/api/units/units-auto-complete',
  data: '/admin/api/units',
  export: '/admin/api/units/export',
  route: '/admin/units',
  deletePrecheck: '/admin/api/units/delete-check',
  getById: '/admin/api/units/get-by-id'
};
